import { cva } from 'class-variance-authority';

/**
 * A one-word verdict, tinted by whether it is good news.
 *
 * Every tone is the same three steps of one hue: 800 border, 950 fill, 400 ink.
 */
export const devToolsStatusBadgeVariants = cva(
  'inline-flex items-center rounded border px-1.5 py-0.5 text-[9.5px] font-semibold uppercase tracking-[0.05em]',
  {
    variants: {
      variant: {
        success: 'border-emerald-800 bg-emerald-950 text-emerald-400',
        warning: 'border-amber-800 bg-amber-950 text-amber-400',
        error: 'border-red-800 bg-red-950 text-red-400',
        info: 'border-violet-800 bg-violet-950 text-violet-400',
        neutral: 'border-zinc-800 bg-zinc-900 text-zinc-400',
        primary: 'border-emerald-800 bg-emerald-950 text-emerald-400',
      },
    },
    defaultVariants: { variant: 'neutral' },
  }
);
